/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-16T10:23:54-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-05-01T11:58:21-07:00
*/



import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Avatar from '../../common/Avatar';
// import moment from 'moment-timezone';
import { tsSince } from '../../../common';
import { css, StyleSheet } from 'aphrodite/no-important';
import { dimensions, leading, size, color, spacing, type, textColor, borders, truncate } from '../../../style';

const style = StyleSheet.create({
  msg: {
    boxSizing: 'border-box',
    width: '100%',
    position: 'relative',
    borderBottom: borders.DEFAULT,
    ...spacing.PADDING_LEFT_MD,

    ':last-child': {
      borderBottomWidth: '0'
    },

    [dimensions.SCREEN_MAX_SM]: {
      // paddingLeft: '64px'
    }
  },

  msgContainer: {
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      height: '92px'
    },

  avatar: {
    ...size.SIZE_60X60,
    // flexShrink: 0,
    display: 'table-cell',
    verticalAlign: 'middle',
    ...spacing.PADDING_RIGHT_SM,
    ...spacing.PADDING_LEFT_SM,
    height: 60,
    width: 60
    // position: 'absolute',
    // left: '24px',
    // top: '14px',

    // [dimensions.SCREEN_MAX_SM]: {
    //   ...size.SIZE_40X40,
    //   left: '14px'
    // }
  },

  content: {
    display: 'table-cell',
    verticalAlign: 'middle',
  },

  title: {
    lineHeight: '22px',
    display: 'block',
    ...truncate,

    [dimensions.SCREEN_MIN_XS]: {
      marginRight: 90
    }
  },

  titleText: {
  },

  username: {
    ...type.MD,
    ...leading.TIGHTER,
    ...spacing.PADDING_RIGHT_SM,
    ...type.BOLD
  },

  meta: {
    ...textColor.NORMAL,

    [dimensions.SCREEN_MAX_XS]: {
      display: 'block'
    }
  },

  userInfo: {
    ...truncate
    // display: 'inline',
  },

  userInfoText: {
    whiteSpace: 'nowrap',
    ...truncate,
    ...spacing.PADDING_RIGHT_SM
  },

  timeStamp: {
    position: 'absolute',
    right: '16px',
    lineHeight:'22px',

    ...type.XS,
    ...textColor.NORMAL
  },

  snippet: {
    margin: '0',
    lineHeight: '16px',
    ...textColor.DARK,
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    ...spacing.MARGIN_RIGHT_LG,

    [dimensions.SCREEN_MAX_SM]: {
    }
  },

  ureadSnippet: {
    fontWeight: 'bold',
    ...textColor.DARKER
  },

  isNew: {

    ':before' : {
      content: '" "',
      height: '10px',
      width: '10px',
      position: 'absolute',
      backgroundColor: color.BRAND_1,
      borderRadius: '8px',
      top: '42px',
      left: '8px'
    }
  },

  recieptBadge: {
    display: 'inline-block',
    ...type.XS,
    ...spacing.MARGIN_RIGHT_SM,
    backgroundColor: color.BRAND_1,
    color: '#FFF',
    padding: '0 5px',
    borderRadius: '3px'
  }

})


class MailItem extends Component {

  render() {

    const badge = <b className={css(style.recieptBadge)}>read</b>

    try {
      let { data } = this.props;
      let message = data.last_message.data;
      let profile = data.other_profile.data;
      let user = profile.account.data.username;
      let avatar = profile.avatar.data.urls.thumbs;
      // only show undread icon on inbox
      let pageType = this.props.pageType;
      let unread = Boolean(((message.to_status === 'new') || false) && (pageType!== "sentbox"));

      return (

        <li className={css(style.msg, unread && style.isNew)}>
          <div className={css(style.msgContainer)}>
            <Link className={css(style.avatar)} to={`/~${user}`}>
              <Avatar src={avatar} />
            </Link>
            <Link className={css(style.content)} to={`/messages/${user}`}>
              <div className={css(style.title)}>
                <span className={css(style.userInfo, style.username)}>{user}</span>
                <span className={css(style.timeStamp)}>{tsSince(message.created_at.date)}</span>
                <div className={css(style.userInfo)}>
                  <span className={css(style.userInfoText, style.meta)}>{profile.age} ･ {profile.city}, {profile.region}</span>
                </div>
              </div>
            <p className={css(style.snippet, unread && style.ureadSnippet)}>
              {pageType === 'sentbox' && message.read_dt !== null && badge }
              {message.message}
            </p>
          </Link>
        </div>
      </li>

      );
    } catch(e) {
      // failed to render message.
      return (<li></li>);
    }
  }
}

MailItem.propTypes = {
  isNew: PropTypes.bool
}

export default MailItem;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/MailItem.jsx